export const getDefaultCategory = (presetName: string): string => {
  if (presetName.includes('카텍 LM 에이전트') || presetName.includes('카텍 퍼플 에이전트')) {
    return '자동차';
  }
  if (presetName.includes('노머니 LM 에이전트')) {
    return '경제';
  }
  if (presetName.includes('Life LM 에이전트')) {
    return 'Life';
  }
  return '';
};
